/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecuteAssetOcppCommandRequestDto
 */
export interface ExecuteAssetOcppCommandRequestDto {
    /**
     * OCPP command. Supported: Reset, ClearCache, GetLocalListVersion, GetConfiguration, TriggerMessage, ChangeConfiguration (HeartbeatInterval only), GetDiagnostics (location is EVIMO-built; never send location).
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    action: ExecuteAssetOcppCommandRequestDtoActionEnum;
    /**
     * Required for Reset. Must be omitted for other actions.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    type?: ExecuteAssetOcppCommandRequestDtoTypeEnum;
    /**
     * Required for GetConfiguration. Curated OCPP 1.6 keys only. Mapped to OCPP GetConfiguration.key.
     * @type {Array<string>}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    keys?: Array<ExecuteAssetOcppCommandRequestDtoKeysEnum>;
    /**
     * Required for TriggerMessage. Curated MessageTrigger values.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    requestedMessage?: ExecuteAssetOcppCommandRequestDtoRequestedMessageEnum;
    /**
     * Required for ChangeConfiguration. Phase 3 allows HeartbeatInterval only.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    key?: ExecuteAssetOcppCommandRequestDtoKeyEnum;
    /**
     * Required for ChangeConfiguration. Positive integer string for OCPP ChangeConfiguration.value. EVIMO allows 10–3600 seconds for HeartbeatInterval.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    value?: string;
    /**
     * Optional for GetDiagnostics. OCPP retries count. Must be omitted for other actions. location is never accepted from the client.
     * @type {number}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    retries?: number;
    /**
     * Optional for GetDiagnostics. Seconds between retries. Must be omitted for other actions.
     * @type {number}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    retryInterval?: number;
    /**
     * Optional for GetDiagnostics. Inclusive start of log window (ISO-8601). Must be omitted for other actions.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    startTime?: string;
    /**
     * Optional for GetDiagnostics. Inclusive end of log window (ISO-8601). Must be >= startTime when both set.
     * @type {string}
     * @memberof ExecuteAssetOcppCommandRequestDto
     */
    stopTime?: string;
}


/**
 * @export
 */
export const ExecuteAssetOcppCommandRequestDtoActionEnum = {
    Reset: 'Reset',
    ClearCache: 'ClearCache',
    GetLocalListVersion: 'GetLocalListVersion',
    GetConfiguration: 'GetConfiguration',
    TriggerMessage: 'TriggerMessage',
    ChangeConfiguration: 'ChangeConfiguration',
    GetDiagnostics: 'GetDiagnostics'
} as const;
export type ExecuteAssetOcppCommandRequestDtoActionEnum = typeof ExecuteAssetOcppCommandRequestDtoActionEnum[keyof typeof ExecuteAssetOcppCommandRequestDtoActionEnum];

/**
 * @export
 */
export const ExecuteAssetOcppCommandRequestDtoTypeEnum = {
    Soft: 'Soft',
    Hard: 'Hard'
} as const;
export type ExecuteAssetOcppCommandRequestDtoTypeEnum = typeof ExecuteAssetOcppCommandRequestDtoTypeEnum[keyof typeof ExecuteAssetOcppCommandRequestDtoTypeEnum];

/**
 * @export
 */
export const ExecuteAssetOcppCommandRequestDtoKeysEnum = {
    HeartbeatInterval: 'HeartbeatInterval',
    ConnectionTimeOut: 'ConnectionTimeOut',
    MeterValueSampleInterval: 'MeterValueSampleInterval',
    ClockAlignedDataInterval: 'ClockAlignedDataInterval',
    NumberOfConnectors: 'NumberOfConnectors',
    GetConfigurationMaxKeys: 'GetConfigurationMaxKeys'
} as const;
export type ExecuteAssetOcppCommandRequestDtoKeysEnum = typeof ExecuteAssetOcppCommandRequestDtoKeysEnum[keyof typeof ExecuteAssetOcppCommandRequestDtoKeysEnum];

/**
 * @export
 */
export const ExecuteAssetOcppCommandRequestDtoRequestedMessageEnum = {
    StatusNotification: 'StatusNotification',
    Heartbeat: 'Heartbeat',
    MeterValues: 'MeterValues',
    BootNotification: 'BootNotification',
    FirmwareStatusNotification: 'FirmwareStatusNotification',
    DiagnosticsStatusNotification: 'DiagnosticsStatusNotification'
} as const;
export type ExecuteAssetOcppCommandRequestDtoRequestedMessageEnum = typeof ExecuteAssetOcppCommandRequestDtoRequestedMessageEnum[keyof typeof ExecuteAssetOcppCommandRequestDtoRequestedMessageEnum];

/**
 * @export
 */
export const ExecuteAssetOcppCommandRequestDtoKeyEnum = {
    HeartbeatInterval: 'HeartbeatInterval'
} as const;
export type ExecuteAssetOcppCommandRequestDtoKeyEnum = typeof ExecuteAssetOcppCommandRequestDtoKeyEnum[keyof typeof ExecuteAssetOcppCommandRequestDtoKeyEnum];


/**
 * Check if a given object implements the ExecuteAssetOcppCommandRequestDto interface.
 */
export function instanceOfExecuteAssetOcppCommandRequestDto(value: object): value is ExecuteAssetOcppCommandRequestDto {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function ExecuteAssetOcppCommandRequestDtoFromJSON(json: any): ExecuteAssetOcppCommandRequestDto {
    return ExecuteAssetOcppCommandRequestDtoFromJSONTyped(json, false);
}

export function ExecuteAssetOcppCommandRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteAssetOcppCommandRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'type': json['type'] == null ? undefined : json['type'],
        'keys': json['keys'] == null ? undefined : json['keys'],
        'requestedMessage': json['requestedMessage'] == null ? undefined : json['requestedMessage'],
        'key': json['key'] == null ? undefined : json['key'],
        'value': json['value'] == null ? undefined : json['value'],
        'retries': json['retries'] == null ? undefined : json['retries'],
        'retryInterval': json['retryInterval'] == null ? undefined : json['retryInterval'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'stopTime': json['stopTime'] == null ? undefined : json['stopTime'],
    };
}

export function ExecuteAssetOcppCommandRequestDtoToJSON(json: any): ExecuteAssetOcppCommandRequestDto {
    return ExecuteAssetOcppCommandRequestDtoToJSONTyped(json, false);
}

export function ExecuteAssetOcppCommandRequestDtoToJSONTyped(value?: ExecuteAssetOcppCommandRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'type': value['type'],
        'keys': value['keys'],
        'requestedMessage': value['requestedMessage'],
        'key': value['key'],
        'value': value['value'],
        'retries': value['retries'],
        'retryInterval': value['retryInterval'],
        'startTime': value['startTime'],
        'stopTime': value['stopTime'],
    };
}

